/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Improve_Body_1Inputs */

const en_how_we_work_improve_body_1 = /** @type {(inputs: How_We_Work_Improve_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processes change. Documents get updated. New exceptions appear. Ongoing work can include monitoring runs, investigating failures and refining how the system behaves.`)
};

const lv_how_we_work_improve_body_1 = /** @type {(inputs: How_We_Work_Improve_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesi mainās. Dokumenti tiek atjaunoti. Parādās jauni izņēmumi. Turpmākais darbs var ietvert izpilžu uzraudzību, kļūmju izmeklēšanu un sistēmas rīcības precizēšanu.`)
};

/**
* | output |
* | --- |
* | "Processes change. Documents get updated. New exceptions appear. Ongoing work can include monitoring runs, investigating failures and refining how the system ..." |
*
* @param {How_We_Work_Improve_Body_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_improve_body_1 = /** @type {((inputs?: How_We_Work_Improve_Body_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Improve_Body_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_improve_body_1(inputs)
	return en_how_we_work_improve_body_1(inputs)
});